export default __webpack_public_path__ + "static/media/cause1.6e7acc1c.png";